import React from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import FileUpload from "../../inputs/FileUpload";
import { COLORS } from "../hooks/useSignupFlow";

const VisualIdentityStep = () => {
  const { t } = useTranslation("signup");
  const { values, errors, touched, handleChange, setFieldValue, setFieldTouched } = useFormikContext();

  return (
    <div className="field-row i-mb-8">
      <div className="field-block grid-full">
        <div className="website-generate-field input-text">
          <label>{t("platform_link")}<span className="asterisk">*</span></label>
          <div className="field">
            <span>tadarab.com.</span>
            <input
              type="text"
              name="domain"
              value={values.domain}
              onChange={handleChange}
              onBlur={() => setFieldTouched("domain", true, false)}
            />
          </div>
          {touched.domain && errors.domain && (
            <div className="input-error">{errors.domain}</div>
          )}
        </div>
        <p className="step-helper-text">{t("platform_link_helper")}</p>
      </div>

      <div className="field-block grid-full">
        <label className="step-label">{t("color_scheme")}</label>
        <div className="color-picker-container">
          {COLORS.map((color) => (
            <div
              key={color}
              onClick={() => {
                setFieldValue("brandColor", color);
              }}
              className={`color-circle ${values.brandColor === color ? "active" : ""}`}
              style={{ backgroundColor: color }}
            />
          ))}
        </div>
      </div>

      <div className="field-block grid-full">
        <FileUpload
          label={t("company_logo")}
          maxSize={5}
          accept={"image/jpg, image/jpeg, image/png"}
          initialFile={values.logo}
          onFileSelect={(file) => {
            setFieldValue("logo", file);
          }}
        />
      </div>
    </div>
  );
};

export default VisualIdentityStep;
